<template>
  <LogInModal>
    <p>
      {{ t('password_reset.description') }}
      <strong>{{ t('password_reset.description_2') }}</strong
      >.
    </p>

    <form @submit="save">
      <LogInField
        v-model="formData.password"
        :placeholder="t('password_reset.new_password')"
        type="password"
      />

      <LogInField
        v-model="formData.passwordConfirmation"
        :placeholder="t('password_reset.confirm_password')"
        type="password"
      />

      <LogInModalSaveButton :disabled="!canSave()">
        {{ t('password_reset.save') }}
      </LogInModalSaveButton>
      <LocaleSelectorLogin />
      <LogInModalBackLink :to="{ path: `/` }">
        {{ t('password_reset.to_front') }}
      </LogInModalBackLink>
    </form>
  </LogInModal>
</template>

<script>
import './style.scss'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from '@/composables/useI18n'
import LogInModal from '@/components/LogInModal'
import LogInField from '@/components/LogInField'
import LogInModalSaveButton from '@/components/LogInModalSaveButton'
import LogInModalBackLink from '@/components/LogInModalBackLink'
import LocaleSelectorLogin from '@/components/LocaleSelectorLogin'

import router from '@/routes'

export default {
  name: 'PasswordReset',
  components: {
    LogInModal,
    LogInField,
    LogInModalSaveButton,
    LogInModalBackLink,
    LocaleSelectorLogin,
  },
  setup() {
    const store = useStore()
    const { t } = useI18n()

    const formData = ref({
      password: '',
      passwordConfirmation: '',
    })

    const query = computed(() => store.getters.query)

    const canSave = () => {
      if (formData.value.password.length < 6) return false
      if (formData.value.password !== formData.value.passwordConfirmation)
        return false
      return true
    }

    const save = event => {
      event.preventDefault()

      store
        .dispatch('resetPassword', {
          token: query.value.token,
          passwordParams: formData.value,
        })
        .then(() => {
          router.push({ name: 'LogIn' })
          store.dispatch('showFlashMessage', {
            message: t('flash_messages.custom.password_reset_success'),
          })
        })
        .catch(e => {
          store.dispatch('showFlashMessage', {
            message: t('flash_messages.custom.password_reset_success'),
          })
        })
    }

    return {
      formData,
      query,
      canSave,
      save,
    }
  },
}
</script>
